import _ from "lodash";
import { toast } from "react-toastify";

import API from "../../api";
import { formatResponse } from "../../formatResponses/reports";
import { useCustomersReport } from "../../../store/reports/useCustomersReport";

export default class CustomersReportModel {
  setCustomersReport = useCustomersReport.getState().actions.setCustomersReport;
  clearCustomersReport = useCustomersReport.getState().actions.clearCustomersReport;
  setSummaryData = useCustomersReport.getState().actions.setSummary;
  setLoading = useCustomersReport.getState().actions.setLoading;
  setWaiting = useCustomersReport.getState().actions.setWaiting;
  setFilterData = useCustomersReport.getState().actions.setFilter;
  setSortData = useCustomersReport.getState().actions.setSort;
  setPaginationPage = useCustomersReport.getState().actions.setPaginationPage;

  constructor() {
    this.name = "reports-store-customers";

    // sem campo de data na tela, o relatorio cobre todo o historico
    this.setFilterData({ dateFrom: null, dateTo: null });
  }

  currentFilter() {
    return useCustomersReport.getState().data.filter;
  }

  currentSort() {
    return useCustomersReport.getState().data.sort;
  }

  setFilter(filterProps) {
    this.setFilterData(filterProps);
  }

  setSort(sortProps) {
    this.setSortData(sortProps);
  }

  async setPage(page) {
    const pageExists = useCustomersReport.getState().data.customersReport[page];
    this.setPaginationPage(page);

    if (!pageExists) await this.getCustomersReport();
  }

  async findCustomersReport() {
    await this.getCustomersReport();
  }

  async filterCustomersReport() {
    this.setLoading(true);
    this.setPaginationPage(0);
    this.clearCustomersReport();
    await this.getCustomersReport();
    this.setLoading(false);
  }

  async getCustomersReport() {
    try {
      this.setWaiting(true);

      const { data } = await API.get("reports/customers", {
        params: this.options(),
      });

      const page = useCustomersReport.getState().data.pagination.page;

      const customers = formatResponse.customersReport(data?.results);
      const pagination = formatResponse.listPagination(data?.pagination, page);

      this.setCustomersReport(customers, pagination);
      if (data?.panel) this.setSummaryData(formatResponse.customersPanel(data.panel));

      this.setWaiting(false);
    } catch (error) {
      const message =
        error?.response?.data?.friendly_message ||
        error?.message ||
        "Não foi possível carregar o relatório de clientes.";

      toast.error(message, { theme: "colored" });
      this.setWaiting(false);
      return null;
    }
  }

  async export() {
    const filter = useCustomersReport.getState().data.filter;

    try {
      await API.post("reports/export", {
        filters: this.filters(filter),
        type: { name: "customer", format: "xlxs" },
      });

      toast.success(
        "Exportação iniciada. O arquivo aparece em Minhas Exportações.",
        { theme: "colored" }
      );
    } catch (error) {
      const message =
        error?.response?.data?.friendly_message ||
        error?.message ||
        "Não foi possível exportar o relatório.";

      toast.error(message, { theme: "colored" });
    }
  }

  filters(filter) {
    return _.omitBy(
      {
        dateFrom: filter.dateFrom || undefined,
        dateTo: filter.dateTo || undefined,
        hasPackage: filter.hasPackage !== "*" ? filter.hasPackage : undefined,
        isSubscriber: filter.isSubscriber !== "*" ? filter.isSubscriber : undefined,
        minAbsenceDays:
          filter.minAbsenceDays !== "*" ? filter.minAbsenceDays : undefined,
        cpf: filter.cpf ? filter.cpf.replace(/\D/g, "") : undefined,
        search: filter.search || undefined,
      },
      _.isUndefined
    );
  }

  options() {
    const filter = useCustomersReport.getState().data.filter;
    const sort = useCustomersReport.getState().data.sort;
    const pagination = useCustomersReport.getState().data.pagination;

    return {
      // o backend e 1-based; a store e 0-based
      currentePage: (pagination.page || 0) + 1,
      perPage: pagination.perPage || 50,
      sortBy: sort.sortBy,
      sortOrder: sort.sortOrder,
      ...this.filters(filter),
    };
  }
}
